import { formatRelative } from 'date-fns';
import { enGB } from 'date-fns/locale';
export const formatRelativeTime = (date: Date): string => {
    // Use the current date as the base date for relative formatting
    const baseDate = new Date();

    // Format the date relative to the current date
    // Use the enGB locale for British English formatting giving 24h clock
    return formatRelative(date, baseDate, { locale: enGB });
};
